import { render, staticRenderFns } from "./Diagnostyki.vue?vue&type=template&id=48ab8ef7&scoped=true&"
import script from "./Diagnostyki.vue?vue&type=script&lang=js&"
export * from "./Diagnostyki.vue?vue&type=script&lang=js&"
import style0 from "./Diagnostyki.vue?vue&type=style&index=0&id=48ab8ef7&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48ab8ef7",
  null
  
)

export default component.exports